// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ag-row[data-v-559d7514] {\n  font-size: 35px;\n}\n", ""]);
// Exports
module.exports = exports;
